import React from "react";

import { MODALS } from "renter/config/constants";
import { Modal } from "shared/components/Modal";

import { EditApplicationProps } from "./interfaces";
import EditApplicationModalContent from "./EditApplicationModalContent";

const EditApplicationModal = ({
  apartment,
  loading,
  submit,
  onClose,
}: EditApplicationProps) => (
  <Modal
    id={MODALS.editApplication}
    width="auto"
    style={{ maxWidth: 440 }}
    submit={submit}
    submitting={loading}
    closeOnSubmit={false}
    showTitle={false}
    showFooter={false}
  >
    <EditApplicationModalContent
      loading={loading}
      onConfirm={submit}
      onClose={onClose}
    />
  </Modal>
);

export default EditApplicationModal;
